(function() {
	angular.module('meanApp').controller('contactCtrl', contactCtrl);

	contactCtrl.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'context',
		'$state'
	];
	function contactCtrl($scope, $rootScope, $location, context, $state) {
		//var vm = this;

		context.set({
			title : "Contact par email, What's app, Facebook, Linkedin, ou Instagram",
			contextName: 'Contact',
			goBack: true
		});
    }
})();
